import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const microsoftOutlook = defineConnector({
  identifier: "microsoftOutlook",
  name: "Microsoft Outlook",
  tagLine: "Email and calendar management",
  keywords: "hotmail exchange office 365 m365 graph email inbox calendar",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  defaultUrlPattern: () => "https://graph\\.microsoft\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Microsoft Outlook account",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    tokenEndpoint: () =>
      "https://login.microsoftonline.com/common/oauth2/v2.0/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://graph.microsoft.com/v1.0/me",
  },
});
